import { UseLoadingReturn } from "@/hooks/use-loading";
import orderService from "@/services/order.service";

import useRemove from "../../use-remove";

export type UseRemoveItemReturn = {
  removeItem: (props: {
    orderId: number;
    itemId: number;
    successMessage?: string;
    errorMessage?: string;
    onSuccess?: () => void;
  }) => Promise<void>;
} & UseLoadingReturn;

const useRemoveItem = (): UseRemoveItemReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, remove } = useRemove({
    operation: (_id, secondaryId) => {
      if (secondaryId === undefined) {
        throw new Error("Item ID is missing");
      }
      return orderService.deleteItem(_id, secondaryId);
    },
  });

  const removeItem = async ({
    orderId,
    itemId,
    successMessage,
    errorMessage,
    onSuccess,
  }: {
    orderId: number;
    itemId: number;
    successMessage?: string;
    errorMessage?: string;
    onSuccess?: () => void;
  }) => {
    await remove({
      _id: orderId,
      secondaryId: itemId,
      onSuccess: onSuccess,
      successMessage: successMessage,
      errorMessage: errorMessage,
    });
  };

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    removeItem,
  };
};

export default useRemoveItem;
